var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"error-m"},[_c('b-img-lazy',{attrs:{"src":require('/src/assets/common/img/404.png'),"blank-color":"#f3f3f3"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }